// extracted by mini-css-extract-plugin
module.exports = {"gallery":"style_gallery__j1djD","active":"style_active__8tPSU","inactive":"style_inactive__VD3AD"};